import { useState } from 'react';
import { createStore } from 'reusable';

export const useIsPermissionsModalOpen = createStore(() => useState(false));
